module.exports = __webpack_public_path__ + "img/sr.36b24d9b.svg";